import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const PROFILE_GET_REQUEST = 'GET_PROFILE_REQUEST';
export const PROFILE_GET_FAILURE = 'GET_PROFILE_FAILURE';
export const PROFILE_GET_SUCCESS = 'GET_PROFILE_SUCCESS';

export const getProfile = id => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(fetchRequest());
        return axios(apiRequestOptions(apiPath.PROFILES.GET, null, {params}))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => ({type: PROFILE_GET_REQUEST})
const fetchFailure = error => ({type: PROFILE_GET_FAILURE, error})
const fetchSuccess = profile => ({type: PROFILE_GET_SUCCESS, profile})
